// generated by tools/build_site.mjs — do not edit by hand
// Source: design-tokens.json

/** Measured face colours from Roblox's official template. Never tune these. */
export const FACE = {
  front: "#E2231A",
  back: "#0074BD",
  left: "#F6B702",
  right: "#02B757",
  up: "#00A2FF",
  down: "#F68802",
} as const;

export type FaceKey = keyof typeof FACE;

/** OKLCH ramps, identical to the custom properties in public/site.css. */
export const RAMP = {
  azure: {
    50: "oklch(0.972 0.0210 245.42)",
    100: "oklch(0.938 0.0385 245.42)",
    200: "oklch(0.885 0.0700 245.42)",
    300: "oklch(0.812 0.1085 245.42)",
    400: "oklch(0.735 0.1487 245.42)",
    500: "oklch(0.664 0.1750 245.42)",
    600: "oklch(0.585 0.1750 245.42)",
    700: "oklch(0.505 0.1540 245.42)",
    800: "oklch(0.42 0.1260 245.42)",
    900: "oklch(0.33 0.0963 245.42)",
    950: "oklch(0.24 0.0700 245.42)",
    975: "oklch(0.18 0.0525 245.42)",
    1000: "oklch(0.13 0.0385 245.42)",
  },
  blue: {
    50: "oklch(0.972 0.0171 246.87)",
    100: "oklch(0.938 0.0313 246.87)",
    200: "oklch(0.885 0.0570 246.87)",
    300: "oklch(0.812 0.0883 246.87)",
    400: "oklch(0.735 0.1211 246.87)",
    500: "oklch(0.664 0.1425 246.87)",
    600: "oklch(0.585 0.1425 246.87)",
    700: "oklch(0.505 0.1254 246.87)",
    800: "oklch(0.42 0.1026 246.87)",
    900: "oklch(0.33 0.0784 246.87)",
    950: "oklch(0.24 0.0570 246.87)",
    975: "oklch(0.18 0.0427 246.87)",
    1000: "oklch(0.13 0.0313 246.87)",
  },
  red: {
    50: "oklch(0.972 0.0268 29.08)",
    100: "oklch(0.938 0.0491 29.08)",
    200: "oklch(0.885 0.0892 29.08)",
    300: "oklch(0.812 0.1383 29.08)",
    400: "oklch(0.735 0.1896 29.08)",
    500: "oklch(0.664 0.2231 29.08)",
    600: "oklch(0.585 0.2231 29.08)",
    700: "oklch(0.505 0.1963 29.08)",
    800: "oklch(0.42 0.1606 29.08)",
    900: "oklch(0.33 0.1227 29.08)",
    950: "oklch(0.24 0.0892 29.08)",
    975: "oklch(0.18 0.0669 29.08)",
    1000: "oklch(0.13 0.0491 29.08)",
  },
  green: {
    50: "oklch(0.972 0.0222 150.5)",
    100: "oklch(0.938 0.0407 150.5)",
    200: "oklch(0.885 0.0741 150.5)",
    300: "oklch(0.812 0.1148 150.5)",
    400: "oklch(0.735 0.1574 150.5)",
    500: "oklch(0.664 0.1852 150.5)",
    600: "oklch(0.585 0.1852 150.5)",
    700: "oklch(0.505 0.1630 150.5)",
    800: "oklch(0.42 0.1333 150.5)",
    900: "oklch(0.33 0.1019 150.5)",
    950: "oklch(0.24 0.0741 150.5)",
    975: "oklch(0.18 0.0556 150.5)",
    1000: "oklch(0.13 0.0407 150.5)",
  },
  amber: {
    50: "oklch(0.972 0.0201 83.44)",
    100: "oklch(0.938 0.0368 83.44)",
    200: "oklch(0.885 0.0669 83.44)",
    300: "oklch(0.812 0.1037 83.44)",
    400: "oklch(0.735 0.1422 83.44)",
    500: "oklch(0.664 0.1673 83.44)",
    600: "oklch(0.585 0.1673 83.44)",
    700: "oklch(0.505 0.1472 83.44)",
    800: "oklch(0.42 0.1205 83.44)",
    900: "oklch(0.33 0.0920 83.44)",
    950: "oklch(0.24 0.0669 83.44)",
    975: "oklch(0.18 0.0502 83.44)",
    1000: "oklch(0.13 0.0368 83.44)",
  },
  orange: {
    50: "oklch(0.972 0.0208 58.74)",
    100: "oklch(0.938 0.0382 58.74)",
    200: "oklch(0.885 0.0694 58.74)",
    300: "oklch(0.812 0.1076 58.74)",
    400: "oklch(0.735 0.1475 58.74)",
    500: "oklch(0.664 0.1735 58.74)",
    600: "oklch(0.585 0.1735 58.74)",
    700: "oklch(0.505 0.1527 58.74)",
    800: "oklch(0.42 0.1249 58.74)",
    900: "oklch(0.33 0.0954 58.74)",
    950: "oklch(0.24 0.0694 58.74)",
    975: "oklch(0.18 0.0520 58.74)",
    1000: "oklch(0.13 0.0382 58.74)",
  },
  violet: {
    50: "oklch(0.972 0.0228 303)",
    100: "oklch(0.938 0.0418 303)",
    200: "oklch(0.885 0.0760 303)",
    300: "oklch(0.812 0.1178 303)",
    400: "oklch(0.735 0.1615 303)",
    500: "oklch(0.664 0.1900 303)",
    600: "oklch(0.585 0.1900 303)",
    700: "oklch(0.505 0.1672 303)",
    800: "oklch(0.42 0.1368 303)",
    900: "oklch(0.33 0.1045 303)",
    950: "oklch(0.24 0.0760 303)",
    975: "oklch(0.18 0.0570 303)",
    1000: "oklch(0.13 0.0418 303)",
  },
  neutral: {
    50: "oklch(0.972 0.0006 70)",
    100: "oklch(0.938 0.0011 70)",
    200: "oklch(0.885 0.0020 70)",
    300: "oklch(0.812 0.0031 70)",
    400: "oklch(0.735 0.0043 70)",
    500: "oklch(0.664 0.0050 70)",
    600: "oklch(0.585 0.0050 70)",
    700: "oklch(0.505 0.0044 70)",
    800: "oklch(0.42 0.0036 70)",
    900: "oklch(0.33 0.0028 70)",
    950: "oklch(0.24 0.0020 70)",
    975: "oklch(0.18 0.0015 70)",
    1000: "oklch(0.13 0.0011 70)",
  },
} as const;

export const RADIUS = {
  "sm": "6px",
  "md": "10px",
  "lg": "14px",
  "full": "999px"
} as const;
export const SPACE = {
  "3xs": "2px",
  "2xs": "4px",
  "xs": "8px",
  "sm": "12px",
  "md": "16px",
  "lg": "24px",
  "xl": "32px",
  "2xl": "48px",
  "3xl": "64px"
} as const;
export const MOTION = {
  "fast": "120ms",
  "base": "160ms",
  "slow": "240ms",
  "ease": "cubic-bezier(0.2, 0, 0, 1)"
} as const;
